import { createAxios } from '../auth'
import { IRIS_BASE_URL } from '.'

/** One ICE server entry (matches the browser's RTCIceServer shape). */
export interface IceServer {
  urls: string[]
  username?: string
  credential?: string
}

/** Response of GET /api/iris/v1/turn/credentials (ticket D1). */
export interface TurnCredentials {
  iceServers: IceServer[]
  ttl: number
}

/**
 * Fetch short-lived TURN/ICE credentials for the current user. Best-effort: callers should fall
 * back to default STUN if this throws (e.g. 503 when coturn isn't configured on the server).
 */
export async function fetchTurnCredentials(token: string): Promise<TurnCredentials> {
  const resp = await createAxios(token).get<TurnCredentials>(`${IRIS_BASE_URL}/turn/credentials`)
  return resp.data
}
